export class InductionModel {
    
    id: number = 0;

    title: string = '';

    published: number = 0; // Represents a boolean

}